import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme, props) {
  var printMq = '@media print';
  var getStylesForGradeStatus = function getStylesForGradeStatus() {
    switch (props.gradeStatus) {
      case 'correct':
        return {
          borderColor: componentTheme.correctBorderColor,
          backgroundColor: componentTheme.correctBackgroundColor,
          fontSize: componentTheme.correctFontSize
        };
      case 'incorrect':
        return {
          borderColor: componentTheme.incorrectBorderColor,
          backgroundColor: componentTheme.incorrectBackgroundColor,
          fontSize: componentTheme.incorrectFontSize
        };
      case 'graded':
        return {
          borderColor: componentTheme.gradedBorderColor,
          backgroundColor: componentTheme.gradedBackgroundColor,
          fontSize: componentTheme.gradedFontSize
        };
      default:
        return {
          borderColor: componentTheme.contentBorderColor,
          backgroundColor: componentTheme.contentBackgroundColor
        };
    }
  };
  return {
    content: _defineProperty({
      width: '100%',
      minHeight: '3rem',
      borderRadius: componentTheme.contentBorderRadius,
      display: 'inline-flex',
      backgroundColor: componentTheme.contentBackgroundColor,
      border: "solid ".concat(componentTheme.contentBorder),
      borderColor: getStylesForGradeStatus().borderColor
    }, printMq, {
      display: 'flex'
    }),
    userResponse: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingLeft: componentTheme.userResponsePadding
    },
    iconHolder: {
      minWidth: '3rem',
      minHeight: '3rem' /* Needed for IE 11 */,
      fontSize: componentTheme.iconHolderFontSize,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: componentTheme.iconHolderColor,
      backgroundColor: getStylesForGradeStatus().backgroundColor,
      fontsize: getStylesForGradeStatus().fontSize
    },
    gradeTextHolder: {
      minHeight: '1.5rem',
      whiteSpace: 'initial',
      display: 'flex',
      alignItems: 'center'
    }
  };
};
export default generateStyle;